import React from "react";
import { ReactComponent as Clipboard } from '../assets/clipboard-list.svg';
import { ReactComponent as Board } from '../assets/kanban.svg';
import { ReactComponent as Menu } from '../assets/menu-square.svg';
import { ReactComponent as Calendar } from '../assets/calendar-clock.svg';
import { ReactComponent as User } from '../assets/user-round.svg';
import { ReactComponent as Payments } from '../assets/credit-card.svg';
import { ReactComponent as Promocodes } from '../assets/promocodes.svg';
import { ReactComponent as Clients } from '../assets/user-round.svg';
import instagramLogo from "../assets/instagram.svg";
import facebookLogo from "../assets/facebook.svg";

// Delivery icon as inline SVG component
export const Delivery = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 3h15v13H1zM16 8h4l3 3v5h-7V8z" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
    </svg>
);

// Settings icon
export const SettingsIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
);

// Dashboard icon (layout grid)
export const DashboardIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="9" rx="1" />
        <rect x="14" y="3" width="7" height="5" rx="1" />
        <rect x="14" y="12" width="7" height="9" rx="1" />
        <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
);

// Chat icon
export const ChatIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
    </svg>
);

// These options will be dynamically translated in the components
export const SelectOption = [
    { value: "REQUESTED", label: "Requested" },
    { value: "PREPARING", label: "Preparing" },
    { value: "READY_FOR_DELIVERY", label: "Ready" },
    { value: "DECLINED", label: "Declined" },
];

// These options will be dynamically translated in the components
export const SelectOptionForCustomDelivery = [
    ...SelectOption,
    { value: "DELIVERY_IN_PROGRESS", label: "Delivery in progress" },
    { value: "DELIVERED", label: "Delivered" },
];

// Menu items will be dynamically translated in the Menu component
export const MenuItems = [
    { key: 'Orders', icon: <Clipboard />, label: 'Պատվերներ', path: '/orders' },
    { key: 'OrderBoard', icon: <Board />, label: 'Տախտակ', path: '/orders/board' },
    { key: 'Chat', icon: <ChatIcon />, label: 'Չատ', path: '/chat' },
    { key: 'Menu', icon: <Menu />, label: 'Մենյու', path: '/menu' },
    { key: 'Schedule', icon: <Calendar />, label: 'Գրաֆիկ', path: '/schedule' },
    { key: 'Profile', icon: <User />, label: 'Պրոֆիլ', path: '/profile' },
    { key: 'Payments', icon: <Payments />, label: 'Վճարներ', path: '/payments' },
    { key: 'Promo', icon: <Promocodes />, label: 'Պրոմոկոդեր', path: '/promocodes' },
    { key: 'Clients', icon: <Clients />, label: 'Հաճախորդներ', path: '/clients' },
    { key: 'Integrations', icon: <SettingsIcon />, label: 'Ինտեգրումներ', path: '/integrations' },
];

export const SocialLinks = [
    {
        logo: facebookLogo,
        href: "https://www.facebook.com/share/18kiaYPUia/?mibextid=JRoKGi",
        alt: "Facebook"
    },
    {
        logo: instagramLogo,
        href: "https://www.instagram.com/bychef.am",
        alt: "Instagram"
    }
];

export const OrderSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: "#f3f4f6",
        color: "#EA580C",
        fontSize: "14px",
        fontWeight: "700",
        minHeight: "40px",
        height: "40px",
        paddingRight: "12px", // Consistent padding to move arrow away from right edge
        borderColor: "",
        boxShadow: "",
        justifyContent: "center",
        borderRadius: "8px",
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: "40px",
        padding: "0 12px",
        display: "flex",
        alignItems: "center",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "#EA580C",
        fontWeight: "700",
        fontSize: "14px",
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: "40px",
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color:
            state.selectProps.value?.value === "REQUESTED"
                ? "#000"
                : state.selectProps.value?.value === "PREPARING"
                    ? "#EA580C"
                    : state.selectProps.value?.value === "READY_FOR_DELIVERY"
                        ? "#15803D"
                        : state.selectProps.value?.value === "DECLINED"
                            ? "#DC2626"
                            : "#374151",
        fontSize: "14px",
        fontWeight: "700",
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color:
            state.data.value === "REQUESTED"
                ? "#000"
                : state.data.value === "REQUESTED"
                    ? "#EA580C"
                    : state.data.value === "READY_FOR_DELIVERY"
                        ? "#15803D"
                        : state.data.value === "DECLINED"
                            ? "#DC2626"
                            : "#374151",
        fontSize: "14px",
        fontWeight: "700",
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: "#fff",
        borderRadius: "8px",
        marginTop: "4px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: 5,
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: "",
        color:
            state.data.value === "REQUESTED"
                ? "#000"
                : state.data.value === "PREPARING"
                    ? "#EA580C"
                    : state.data.value === "READY_FOR_DELIVERY"
                        ? "#15803D"
                        : state.data.value === "DECLINED"
                            ? "#DC2626"
                            : "#374151",
        fontSize: "14px",
        fontWeight:
            state.isSelected ||
            state.data.value === "PREPARING" ||
            state.data.value === "READY_FOR_DELIVERY" ||
            state.data.value === "DECLINED"
                ? "700"
                : "500",
        padding: "6px 12px",
        cursor: "pointer",
        minHeight: "32px",
        display: "flex",
        alignItems: "center",
    }),
    menuList: (provided) => ({
        ...provided,
        padding: "0",
        maxHeight: "200px",
        overflowY: "auto",
    }),
};

export const CustomMultiSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: '40px',
        height: 'auto',
        border: state.isFocused ? '1px solid #cfcfcf' : '1px solid #e5e7eb',
        boxShadow: state.isFocused ? '0 0 0 2px rgba(0, 0, 0, 0.1)' : 'none',
        borderRadius: '8px',
        '&:hover': {
            borderColor: '#cfcfcf',
        },
        fontSize: '14px',
        fontWeight: '400',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0 12px',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        minHeight: '40px',
        height: 'auto',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "#9CA3AF",
        fontSize: "14px",
        fontWeight: "400",
    }),
    option: (provided, state) => ({
        ...provided,
        marginTop: "4px",
        marginBottom: "4px",
        height: "36px",
        width: "100%",
        backgroundColor: state.isFocused ? "#f3f4f6" : "#fff",
        color: "#374151",
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: "350px",
        padding: "4px",
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        // Ensures indicators remain positioned correctly
        display: 'flex',
        alignItems: 'center',
        height: 'auto',
    }),
    clearIndicator: (provided) => ({
        ...provided,
        // Centers the clear button icon
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        // Centers the dropdown chevron
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
    }),
};

export const CustomSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        height: "40px",
        minHeight: "40px",
        paddingRight: "8px", // Padding to move arrow away from right edge
        border: state.isFocused ? "1px solid #cfcfcf" : "1px solid #e5e7eb",
        boxShadow: state.isFocused ? "0 0 0 2px rgba(0, 0, 0, 0.1)" : "none",
        borderRadius: "8px",
        "&:hover": {
            borderColor: "#cfcfcf",
        },
        fontSize: "14px",
        fontWeight: "400",
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: "40px",
        padding: "0 8px 0 12px", // Reduced right padding to make room for arrow
        display: "flex",
        alignItems: "center",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "#9CA3AF",
        fontSize: "14px",
        fontWeight: "400",
    }),
    option: (provided, state) => ({
        ...provided,
        marginTop: "4px",
        marginBottom: "4px",
        height: "36px",
        width: "100%",
        backgroundColor: state.isFocused ? "#f3f4f6" : "#fff",
        color: "#374151",
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: "350px",
        padding: "4px",
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: "40px",
        paddingRight: "0px", // No additional padding needed since control handles spacing
        paddingLeft: "8px", // Add left padding to separate from value
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: "8px 8px", // Standard padding, container handles spacing
    }),
};

export const Days = [
    "Երկուշաբթի",
    "Երեքշաբթի",
    "Չորեքշաբթի",
    "Հինգշաբթի",
    "Ուրբաթ",
    "Շաբաթ",
    "Կիրակի"
];

export const DaysTranslations = {
    0: {
        am: "Երկուշաբթի",
        ru: "Понедельник",
        en: "Monday"
    },
    1: {
        am: "Երեքշաբթի",
        ru: "Вторник",
        en: "Tuesday"
    },
    2: {
        am: "Չորեքշաբթի",
        ru: "Среда",
        en: "Wednesday"
    },
    3: {
        am: "Հինգշաբթի",
        ru: "Четверг",
        en: "Thursday"
    },
    4: {
        am: "Ուրբաթ",
        ru: "Пятница",
        en: "Friday"
    },
    5: {
        am: "Շաբաթ",
        ru: "Суббота",
        en: "Saturday"
    },
    6: {
        am: "Կիրակի",
        ru: "Воскресенье",
        en: "Sunday"
    }
};

export const Data = [
    { date: "17/11/2000", id: "12345678", amount: 1234, cashback: "5%", discount: "10%", payment: "iDram" },
    { date: "17/11/2000", id: "12345678", amount: 3456, cashback: "5%", discount: "10%", payment: "Cash" },
    { date: "17/11/2000", id: "12345678", amount: 7654, cashback: "5%", discount: "10%", payment: "Card" },
    { date: "17/11/2000", id: "12345678", amount: 12902, cashback: "5%", discount: "10%", payment: "Cash" },
    { date: "17/11/2000", id: "12345678", amount: 34567, cashback: "5%", discount: "10%", payment: "iDram" },
    { date: "17/11/2000", id: "12345678", amount: 98765, cashback: "5%", discount: "10%", payment: "Card" },
    { date: "17/11/2000", id: "12345678", amount: 1234, cashback: "5%", discount: "10%", payment: "iDram" },
    { date: "17/11/2000", id: "12345678", amount: 431, cashback: "5%", discount: "10%", payment: "Card" },
];

export const StatusColorMap = {
    PENDING: "#FFC107",
    ACTIVE: "#4CAF50",
    DISABLED: "#9E9E9E",
    REJECTED: "#F44336",
    REQUESTED: "#000000",
    PREPARING: "#EA580C",
    READY_FOR_DELIVERY: "#15803D",
    DECLINED: "#DC2626",
};

// This will be dynamically translated in the components
export const StatusTranslationMap = {
    PENDING: "Սպասում է",
    ACTIVE: "Ակտիվ",
    DISABLED: "Անջատված",
    REJECTED: "Մերժված",
    REQUESTED: "Պատվիրված",
    PREPARING: "Պատրաստվում է",
    READY_FOR_DELIVERY: "Պատրաստ է",
    DECLINED: "Մերժված",
};

// This will be dynamically translated in the components
export const SpiceLevelTranslations = {
    'not-spicy': 'Ոչ կծու',
    'mild-spicy': 'Մեղմ կծու',
    'medium-spicy': 'Միջին համ',
    'spicy': 'Կծու',
};

// Yandex Maps API Key
export const YMAP_KEY = process.env.REACT_APP_YMAP_KEY || '';

